<template>
  <div>
    <div class="iqos-grid">
      <div class="iqos-column" v-if="promotions.length">
        <DiscountCard
          class="mb-24"
          v-for="promotion in promotions"
          @deleted="fetchList"
          @updated="fetchList"
          :key="promotion._id"
          :promotion="promotion"
        />
      </div>
      <div class="iqos-column" v-if="showCustomPromotionsBlock">
        <CasinoSettings v-if="showCasinoPromotion"/>
        <FirstOrderDiscount v-if="showCustomPromotionsBlock"/>
      </div>
    </div>

    <CreatePromotion
      @created="
        add_modal = false;
        fetchList();
      "
      v-if="add_modal"
      @close="add_modal = false"
    />
  </div>
</template>

<script>
import PromotionsAPI from "@/api/promotions";

import CreatePromotion from "@/components/marketing/CreatePromotion.vue";
import Popup from "@/components/PopUp.vue";

import DiscountCard from "@/components/marketing/DiscountCard.vue";
import CasinoSettings from "@/components/marketing/CasinoSettings.vue";

import FirstOrderDiscount from "@/components/promotions/FirstOrderDiscount.vue"

export default {
  data() {
    return {
      promotions: [],
      add_modal: false,
    };
  },
  methods: {
    fetchList() {
      PromotionsAPI.getList(this.cafe._id)
        .then((data) => {
          this.promotions = data.promotions;
        })
        .catch((err) => {
          alert(err);
        });
    },
    showAddPromotionUI() {
      this.add_modal = true;
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    showCasinoPromotion() {
      return this.cafe._id == 55 || this.cafe._id == 1;
    },
    showFirstOrderDiscount() {
      return this.cafe._id == 497 || this.cafe._id == 1;
    },
    showCustomPromotionsBlock() {
      return this.showCasinoPromotion || this.showFirstOrderDiscount;
    }
  },
  mounted() {
    this.fetchList();

    if (!this.$store.state.menu.menus.length) {
      this.$store.dispatch("menu/fetchMenus");
    }
  },
  components: {
    CreatePromotion,
    Popup,
    DiscountCard,
    CasinoSettings,
    FirstOrderDiscount
  },
};
</script>

<style>
</style>